<template>
  <div class="min-h-screen bg-gray-50 py-10 px-4">

    <!-- PARAGRAF PEMBUKA -->
    <p class="text-gray-600 text-justify max-w-6xl mx-auto mb-10 leading-relaxed">
      Ringkasan Informasi Produk dan/atau Layanan (RIPLAY) ini disusun oleh BPR Padma sebagai informasi awal bagi calon nasabah mengenai karakteristik, fitur umum, serta ketentuan dasar dari setiap produk atau layanan. Informasi ini tidak bersifat personal dan tidak menggantikan dokumen resmi yang berlaku.
    </p>

    <!-- LOOP PER GROUP -->
    <div 
      v-for="(group, type) in groupedData" 
      :key="type"
      class="max-w-6xl mx-auto py-6 mb-10"
    >
      <div class="grid grid-cols-[1fr_3fr] gap-6">

        <!-- ICON BESAR / GAMBAR -->
        <div class="flex justify-center items-start">
          <img 
            :src="getTypeImage(type)" 
            alt="icon" 
            class="w-full object-cover rounded-2xl shadow"
          />
        </div>

        <!-- TITLE + DESCRIPTION + GRID -->
        <div>
          <!-- TITLE -->
          <h2 class="text-2xl font-bold capitalize mb-3">
            {{ type }}
          </h2>

          <!-- UL DESKRIPSI -->
          <ul class="list-disc pl-6 text-gray-600 mb-6 leading-relaxed">
            <li v-for="(desc, idx) in getTypeDescription(type)" :key="idx">
              {{ desc }}
            </li>
          </ul>

          <!-- GRID PRODUK -->
          <div class="grid grid-cols-3 gap-2">
            <div 
              v-for="item in group" 
              :key="item.id"
              
            >
            <a :href="item.path" target="_blank" class="p-4 border bg-primary hover:bg-secondary rounded-lg flex items-center gap-1 cursor-pointer transition text-white">
              <mdicon :name="item.icon" size="50"/>
              <span class="font-medium text-sm capitalize">{{ item.nama_product }}</span>
            </a>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "RiplayGrid",

  data() {
    return {
      data: []
    };
  },

  computed: {
    groupedData() {
      const groups = {};
      this.data.forEach(item => {
        if (!groups[item.type]) groups[item.type] = [];
        groups[item.type].push(item);
      });
      return groups;
    }
  },

  methods: {
    getData() {
      this.$store.commit("ChangeLoader", true);

      this.axios
        .get(`/api/public/riplay-umum`)
        .then(res => {
          this.data = res.data;
        })
        .finally(() => {
          this.$store.commit("ChangeLoader", false);
        });
    },

    // Gambar besar berdasarkan tipe produk
    getTypeImage(type) {
      const images = {
        tabungan: require('@/assets/riplay/TABUNGAN.png'),
        deposito: require('@/assets/riplay/DEPOSITO.png'),
        kredit: require('@/assets/riplay/KREDIT.png'),
        layanan: require('@/assets/riplay/LAYANAN.png')
      };
      return images[type] ?? require('@/assets/riplay/DEFAULT.png');
    },

    // Deskripsi UL sesuai POJK & BPR Padma
    getTypeDescription(type) {
      const list = {
        tabungan: [
          "Produk simpanan yang disediakan untuk membantu nasabah menyimpan dana secara aman sesuai ketentuan BPR Padma.",
          "Fitur, biaya, ketentuan transaksi, serta persyaratan pembukaan rekening dapat berbeda pada setiap jenis produk.",
          "Informasi ini merupakan ringkasan umum dan tidak menggantikan dokumen resmi syarat dan ketentuan yang berlaku."
        ],

        deposito: [
          "Simpanan berjangka dengan pilihan jangka waktu tertentu sesuai kebijakan BPR Padma.",
          "Ketentuan mengenai bunga, biaya, perpanjangan otomatis, serta pencairan mengikuti regulasi dan kebijakan internal bank.",
          "Calon nasabah diharapkan mempelajari dokumen resmi sebelum mengambil keputusan terkait produk."
        ],

        kredit: [
          "Fasilitas pembiayaan yang diberikan berdasarkan hasil analisis kelayakan dan prinsip kehati-hatian BPR Padma.",
          "Persyaratan pengajuan, proses analisis, biaya terkait, serta kewajiban pembayaran akan dijelaskan dalam dokumen resmi sebelum penandatanganan.",
          "Informasi ini bukan merupakan penawaran kredit maupun jaminan persetujuan."
        ],

        layanan: [
          "Layanan pendukung transaksi perbankan yang tersedia sesuai prosedur operasional BPR Padma.",
          "Ketersediaan dan ketentuan layanan dapat berbeda bergantung pada kebijakan operasional dan fasilitas yang tersedia.",
          "Informasi ini memberikan gambaran umum dan tidak mencakup seluruh ketentuan layanan yang berlaku."
        ]
      };

      return list[type] || [
        "Informasi umum mengenai produk dan layanan BPR Padma.",
        "Untuk detail lengkap, calon nasabah akan memperoleh dokumen resmi sesuai peraturan yang berlaku."
      ];
    }
  },

  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
</style>
